import React, { FC } from 'react';
import { UserCoursesPastContent } from 'src/user/courses/components/UserCoursesPast/UserCoursesPastContent';
import { UserCoursesPastEmpty } from 'src/user/courses/components/UserCoursesPast/UserCoursesPastEmpty';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { UserCoursesSectionHeader } from 'src/user/courses/components/UserCoursesSectionHeader';
import { UserCoursesSectionTitle } from 'src/user/courses/components/UserCoursesSectionTitle';
import { useCurrentUserPastEventsQuery } from 'src/common/hooks/event/useCurrentUserPastEventsQuery';
import { UserCoursesSectionTooltip } from 'src/user/courses/components/UserCoursesSectionTooltip';
import { Button } from 'src/common/components/Button';
import { CourseCardSkeleton } from 'src/common/components/CourseCardSkeleton';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { UserCertificatesRoute } from 'src/user/routes';

const Container = styled.div`
  padding: 3.25rem 0 1.25rem;

  ${media.w.min.px768(css`
    padding-top: 3.75rem;
  `)};

  ${media.w.min.px992(css`
    padding-bottom: 3.75rem;
  `)};
`;

const StyledButton = styled(Button)`
  font-size: inherit;
  line-height: inherit;
`;

const Text = styled.div`
  margin: 1.25rem 0;
`;

export const UserCoursesPast: FC = () => {
  const {
    data: pastEvents,
    isLoading,
    isError,
    isSuccess: pastEventsSuccess,
  } = useCurrentUserPastEventsQuery();

  const isEmpty = pastEventsSuccess && pastEvents?.length === 0;
  const isSome = pastEventsSuccess && (pastEvents?.length ?? 0) > 0;

  return (
    <Container>
      <UserCoursesSectionHeader>
        <UserCoursesSectionTitle>Historia</UserCoursesSectionTitle>

        {isSome && (
          <>
            <UserCoursesSectionTooltip
              kind="internal"
              title={
                <>
                  Chcesz odebrać certyfikat? Wejdź w&nbsp;zakładkę “<u>certyfikaty</u>”
                </>
              }
              to={UserCertificatesRoute}
            >
              Chcesz odebrać certyfikat? Wejdź w&nbsp;zakładkę “
              <StyledButton
                as={GatsbyLink}
                decoration="underline"
                kind="link"
                to={UserCertificatesRoute}
              >
                certyfikaty
              </StyledButton>
              ”
            </UserCoursesSectionTooltip>
          </>
        )}
      </UserCoursesSectionHeader>

      {isLoading && <CourseCardSkeleton />}
      {isError && <Text>Wystapił błąd podczas pobierania wydarzeń.</Text>}
      {isEmpty && <UserCoursesPastEmpty />}
      {isSome && <UserCoursesPastContent items={pastEvents!} />}
    </Container>
  );
};
